import type { LayoutBlock } from '@web-studio/shared-schemas';
import { footerStandardDefault } from '../blocks/footer';
import { heroEditorialDefault } from '../blocks/hero';
import { menuGrid3ColumnDefault } from '../blocks/menu';
import { navigationHeaderDefault } from '../blocks/navigation';

/** Restaurant / minimum tier — implemented blocks only. */
export const restaurantMinimumPage: LayoutBlock[] = [
  navigationHeaderDefault,
  heroEditorialDefault,
  menuGrid3ColumnDefault,
  footerStandardDefault,
];
